var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        title: "详情",
        visible: _vm.drawer,
        "destroy-on-close": true,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
        size: "50%",
        withHeader: "false",
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawer = $event
        },
      },
    },
    [
      _c("div", { staticClass: "title-box" }, [_vm._v("基本信息")]),
      _c(
        "el-descriptions",
        { staticStyle: { "margin-left": "40px" }, attrs: { column: 1 } },
        [
          _c("el-descriptions-item", { attrs: { label: "活动名称" } }, [
            _vm._v(_vm._s(_vm.info.name)),
          ]),
          _c(
            "el-descriptions-item",
            { attrs: { label: "活动链接" } },
            [
              _c("div", { staticClass: "url-box" }, [
                _c(
                  "a",
                  {
                    staticStyle: { color: "#409eff" },
                    attrs: { href: _vm.info.url, target: "_blank" },
                  },
                  [_vm._v(_vm._s(_vm.info.url))]
                ),
              ]),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.copyUrl(_vm.info.url)
                    },
                  },
                },
                [_vm._v("复制")]
              ),
            ],
            1
          ),
          _c("el-descriptions-item", { attrs: { label: "隶属公司" } }, [
            _vm._v(_vm._s(_vm.info.merchantName)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "活动时间" } }, [
            _vm._v(
              _vm._s(_vm.info.startTime) + " 至 " + _vm._s(_vm.info.endTime)
            ),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "title-box" }, [_vm._v("乘客端展示")]),
      _c(
        "el-descriptions",
        { staticStyle: { "margin-left": "40px" }, attrs: { column: 1 } },
        [
          _c(
            "el-descriptions-item",
            { attrs: { label: "活动头图" } },
            [
              _c("el-image", {
                staticStyle: { width: "120px", "margin-left": "30px" },
                attrs: {
                  src: _vm.info.headImgUrl,
                  "preview-src-list": [_vm.info.headImgUrl],
                },
              }),
            ],
            1
          ),
          _c("el-descriptions-item", { attrs: { label: "活动背景色" } }, [
            _vm._v(_vm._s(_vm.info.backcolor)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "活动规则" } }, [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.info.rule) } }),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "title-box" }, [_vm._v("活动奖励")]),
      _c(
        "el-table",
        {
          staticStyle: { margin: "0 10px" },
          attrs: {
            data: _vm.info.couponInfoList,
            border: "",
            size: "mini",
            "max-height": "280px",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "序号",
              type: "index",
              width: "50",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "优惠券名称", align: "center", prop: "couponName" },
          }),
          _c("el-table-column", {
            attrs: { label: "所属礼包", align: "center", prop: "giftName" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "金额/个",
              align: "center",
              prop: "discountsMoney",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "每次领取数量", align: "center", prop: "num" },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "descriptions-text" }, [
        _vm._v("每人限领 " + _vm._s(_vm.info.everyPersonTime) + " 次"),
      ]),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "align-items": "center",
            "margin-bottom": "20px",
          },
        },
        [
          _c("div", { staticClass: "descriptions-text" }, [
            _vm._v("可参与人次："),
          ]),
          _c(
            "el-descriptions",
            {
              staticStyle: { width: "200px" },
              attrs: {
                column: 2,
                border: "",
                direction: "vertical",
                size: "mini",
                contentStyle: _vm.rowCenter,
                labelStyle: _vm.rowCenter,
              },
            },
            [
              _c("el-descriptions-item", { attrs: { label: "总量" } }, [
                _vm._v(_vm._s(_vm.info.personTime)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "剩余" } }, [
                _vm._v(_vm._s(_vm.info.surplus)),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "title-box" }, [_vm._v("其他")]),
      _c(
        "div",
        { staticClass: "bottom-box" },
        [
          _c(
            "el-descriptions",
            { staticStyle: { "margin-left": "40px" }, attrs: { column: 1 } },
            [
              _c("el-descriptions-item", { attrs: { label: "创建人" } }, [
                _vm._v(_vm._s(_vm.info.createUser)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "审核人" } }, [
                _vm._v(_vm._s(_vm.info.auditUser)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "活动状态" } }, [
                _vm._v(_vm._s(_vm.info.statusTr)),
              ]),
              _vm.info.refuseMsg
                ? _c(
                    "el-descriptions-item",
                    { attrs: { label: "不通过原因" } },
                    [_vm._v(_vm._s(_vm.info.refuseMsg))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-descriptions",
            { attrs: { column: 1 } },
            [
              _c("el-descriptions-item", { attrs: { label: "创建时间" } }, [
                _vm._v(_vm._s(_vm.info.createTime)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "审核时间" } }, [
                _vm._v(_vm._s(_vm.info.auditTime)),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }